export const MIN_INTERNATIONAL_PHONE_LENGTH = 5;
export const MAX_INTERNATIONAL_PHONE_LENGTH = 15;
export const DEFAULT_ISD_CODE = "+91";

export const IsdCode = Object.freeze({
  BAHRAIN: "+973",
  INDIA: "+91",
  KUWAIT: "+965",
  QATAR: "+974",
  OMAN: "+968",
  SAUDI_ARABIA: "+966",
  UAE: "+971",
  USA: "+1",
  TURKEY: "+90",
});

export const PHONE_CONFIG = {
  [IsdCode.INDIA]: {
    minLength: 10,
    maxLength: 10,
    pattern: "[6-9]\\d{9}",
  },
  [IsdCode.USA]: {
    minLength: 10,
    maxLength: 10,
    pattern: "[2-9]\\d{9}",
  },
  [IsdCode.UAE]: {
    minLength: 9,
    maxLength: 9,
    pattern: "5\\d{8}",
  },
  [IsdCode.SAUDI_ARABIA]: {
    minLength: 9,
    maxLength: 9,
    pattern: "5\\d{8}",
  },
  [IsdCode.QATAR]: {
    minLength: 8,
    maxLength: 8,
    pattern: "[3567]\\d{7}",
  },
  [IsdCode.OMAN]: {
    minLength: 8,
    maxLength: 8,
    pattern: "[79]\\d{7}",
  },
  [IsdCode.KUWAIT]: {
    minLength: 8,
    maxLength: 8,
    pattern: "[569]\\d{7}",
  },
  [IsdCode.BAHRAIN]: {
    minLength: 8,
    maxLength: 8,
    pattern: "[36]\\d{7}",
  },
  [IsdCode.TURKEY]: {
    minLength: 10,
    maxLength: 10,
    pattern: "5\\d{9}",
  },
};

export const getPhoneConfigForIsd = (isdCode) =>
  PHONE_CONFIG[isdCode] || {
    minLength: MIN_INTERNATIONAL_PHONE_LENGTH,
    maxLength: MAX_INTERNATIONAL_PHONE_LENGTH,
    pattern: "\\d+",
  };

export const isValidPhoneForIsd = (phone, isdCode) => {
  if (!isdCode) {
    return false;
  }

  const digits = String(phone || "").replace(/\D/g, "");
  const { minLength, maxLength, pattern } = getPhoneConfigForIsd(isdCode);

  if (digits.length < minLength || digits.length > maxLength) {
    return false;
  }

  return new RegExp(`^${pattern}$`).test(digits);
};
